//=============================================================================
// Contents   : HRDB
//              派遣社員情報一覧
//              GetTemporaryList
// Author     : RV奥村
// LastUpdate : 2023/03/24
// Since      : 2022/12/11
//=============================================================================

/* ======================================================================================================================================================= */  
/* ==================================================================== Start Of Program ================================================================= */  
/* ======================================================================================================================================================= */ 


/* ======================================================================== */  
/* ============================ import ==================================== */  
/* ======================================================================== */  

/* ====== React ====== */
import React from "react";
/* ====== CSS ====== */

/* ====== Image ====== */

/* ====== Component Js/Jsx ====== */

/* ====== Style ====== */
import { GetListTemp } from "01Pages/Template/GetListTemp";
/* ======================================================================== */  
/* ============================ Styles ==================================== */  
/* ======================================================================== */  

/* ======================================================================== */  
/* ================== global variables/functions ========================== */  
/* ======================================================================== */  

/* ======================================================================== */  
/* ============================ Main ====================================== */  
/* ======================================================================== */  

/* =========  ========= */
export const GetTemporaryList = () => {

    /* ---------------------------------------------------- */
    /* ------------------ Instance ------------------------ */
    /* ---------------------------------------------------- */

    /* ----------------------------------------------------- */
    /* ----------------- reack-hook-form ------------------- */
    /* ----------------------------------------------------- */

    /* ====== hookformを定義 ====== */ 

    /* ====== useWatchを定義 ====== */ 

    /* ---------------------------------------------------- */
    /* ------------------ variables ----------------------- */
    /* ---------------------------------------------------- */
    /* ====== sessionStorageからの情報を定義 ====== */ 

    /* ====== localStorageからの情報を定義 ====== */ 

    /* ====== storageから取得した情報をJavaScriptオブジェクトに変換 ====== */ 

    /* ---------------------------------------------------- */
    /* ---------------------- state ----------------------- */
    /* ---------------------------------------------------- */

    /* ---------------------------------------------------- */
    /* ---------------------- function -------------------- */
    /* ---------------------------------------------------- */
 
    /* ---------------------------------------------------- */
    /* ----------------------- data ----------------------- */
    /* ---------------------------------------------------- */
    /* ====== 取得API項目の設定 ====== */
	const getConfig = {
        key:[
            {name:'sarLiteral' , base64:true}
        ],
        payload:[
            {name:'empNmb',                                   base64:false},
            {name:'empFullName',                              base64:true},
            {name:'empiTermDciFlag',                          base64:false},
            {name:'itrSchedTmpFlag',                          base64:false},
            {name:'gendName',                                 base64:true},
            {name:'tmpAgnCmpCd',    name2:'tmpAgnCmpName',    base64:false, base642:true},
            {name:'tmpAgnCmpCd',             type:'excelItem',base64:false},//excel出力用
            {name:'tmpAgnCmpName',            type:'excelItem',base64:true},//excel出力用
            {name:'entryDate',                                base64:false},
            {name:'tmpCntrTermSrtDate',         type:'date',  base64:false},
            {name:'tmpCntrTermExpiDate',        type:'date',  base64:false},
            {name:'rtiDate',                    type:'date',  base64:false},
            {name:'idiCntDate',                 type:'date',  base64:false},
            {name:'dptCd',                                    base64:false},						
            {name:'tmpFirstDptHqName',                        base64:true},
            {name:'tmpFirstDptPartName',                      base64:true},
            {name:'tmpFirstDptRomName',                       base64:true},
            {name:'tmpFirstDptGpName',                        base64:true},
            {name:'dptOrd',                                   base64:false},
            {name:'tmpFirstRspPsnEmpNmb',                     base64:false},
            {name:'tmpFirstRspEmpFullName',                   base64:true},
            {name:'tmpFirstRspPsnPostName',                   base64:true},
            {name:'ledrEmpNmb',                               base64:false},
            {name:'ledrFullName',                             base64:true},
            {name:'ledrPostName',                             base64:true},
            {name:'workLocoName',                             base64:true},
            {name:'hurRate',                                  base64:false},
            {name:'uitCstRema',                               base64:true},
            {name:'flexAplyFlag',                             base64:false},
            {name:'cntrNtTgtFlag',                            type:Boolean, base64:false},
            {name:'webAttdNtTgtFlag',                         type:Boolean, base64:false},
            {name:'tmpInfoRema',                              base64:true},
            {name:'tmpBsiContField',                          base64:true},
            {name:'tmpBsiContDta',                            base64:true},
            {name:'tmpBfCntrTermSrtDate',                     base64:false},
            {name:'tmpBfCntrTermEndDate',                     base64:false},
            {name:'bfCntrHurRate',                            base64:false},
            {name:'lastUdr',                                  base64:true},
            {name:'lastUpDate',                               base64:false}
        ]              
    };

    /* ====== 更新API項目の設定 ====== */
	const updateConfig = {
        key:['empNmb','tmpCntrTermSrtDate'],
        payload:[
            {name:'empiTermDciFlag',                            type:Boolean,       base64:false},
            {name:'itrSchedTmpFlag',                            type:Boolean,       base64:false},
            {name:'tmpAgnCmpCd',        name2:'tmpAgnCmpName',  type:String,        base64:false, base642: true},
            {name:'tmpCntrTermExpiDate',                        type:String,        base64:false},
            {name:'idiCntDate',                                 type:String,        base64:false},
            {name:'hurRate',                                    type:Number,        base64:false},
            {name:'uitCstRema',                                 type:String,        base64:true},
            {name:'flexAplyFlag',                               type:Boolean,       base64:false},
            {name:'cntrNtTgtFlag',                              type:Boolean,       base64:false},
            {name:'webAttdNtTgtFlag',                           type:Boolean,       base64:false},
            {name:'tmpInfoRema',                                type:String,        base64:true},
            {name:'tmpBsiContField',                            type:String,        base64:true},
            {name:'tmpBsiContDta',                              type:String,        base64:true}
        ]              
    };

    /* ====== headDataの設定 ====== */
    // id       : 項目名
    // id2       : 項目名2
    // rowSpan  : 2~ (縦に結合)
    // colSpan	: 2~ (横に結合)
    // align	: 整列(横方向) Center/inherit/justify/left/right
    // sortTable: true(ソート)
    // fixed	: 位置固定 true
    // left		: 左からの位置	0~
    // right	: 右からの位置 0~
    // width    : セルの幅
    // label1	: 表示名(1段目)
    // label2	: 表示名(2段目)
    // mark     : 入力必須を表す*を表示　
    const headData = [
    	{ id: 'empNmb', align: 'left', width: '115px', sortTable:true, label1: '従業員番号' ,fixed:true,left:'0px'},
    	{ id: 'empFullName', align: 'left', width: '123px', sortTable:true, label1:'氏名',fixed:true,left:'120px', borderRight:'1px solid #c0c0c0' },
        { id: 'empiTermDciFlag', align: 'left', width: '115px', sortTable:true, label1: '雇用期間の', label2:'定め', required: true },
    	{ id: 'itrSchedTmpFlag', align: 'left', width: '100px', sortTable:true, label1: '紹介予定', label2: '派遣',required: true },
    	{ id: 'gendName', align: 'left', width: '70px', sortTable:true, label1: '性別' },
        { id: 'tmpAgnCmpCd', align: 'left', width: '310px', sortTable:true, label1: '派遣元会社', required: true },
        { id: 'entryDate', align: 'left', width: '126px', sortTable:true, label1: '入社日', label2: '(開始日)' },
        { id: 'tmpCntrTermSrtDate', align: 'left', width: '126px', sortTable:true, label1: '契約開始日', required: true },
        { id: 'tmpCntrTermExpiDate', align: 'left', width: '126px', sortTable:true, label1: '契約満了日' },
        { id: 'rtiDate', align: 'left', width: '126px', sortTable:true, label1: '退職日', label2: '(終了日)' },
        { id: 'idiCntDate', align: 'left', width: '126px', sortTable:true, label1: '個人抵触日'},
        { id: 'dptCd', align: 'left', width: '120px', sortTable:true, label1: '部署コード' },
        { id: 'tmpFirstDptHqName', align: 'left', width: '250px', sortTable:true, label1: '部署' },
        { id: 'dptOrd', align: 'left', width: '100px', sortTable:true, label1: '部署順' },
        { id: 'tmpFirstRspPsnEmpNmb', align: 'left', width: '135px', sortTable:true, label1: '派遣先責任者',label2: '従業員番号' },
        { id: 'tmpFirstRspEmpFullName', align: 'left', width: '135px', sortTable:true, label1: '派遣先責任者' },
        { id: 'tmpFirstRspPsnPostName', align: 'left', width: '135px', sortTable:true, label1: '派遣先責任者',label2: '役職' },
        { id: 'ledrEmpNmb', align: 'left', width: '120px', sortTable:true, label1: '指揮命令者',label2: '従業員番号' },
        { id: 'ledrFullName', align: 'left', width: '120px', sortTable:true, label1: '指揮命令者' },
        { id: 'ledrPostName', align: 'left', width: '130px', sortTable:true, label1: '指揮命令者',label2: '役職' },
        { id: 'workLocoName', align: 'left', width: '100px', sortTable:true, label1: '勤務地' },
        { id: 'hurRate', align: 'left', width: '100px', sortTable:true, label1: '時間単価' },
        { id: 'uitCstRema', align: 'left', width: '345px', sortTable:true, label1: '時間単価備考' },
        { id: 'flexAplyFlag', align: 'left', width: '115px', sortTable:true, label1: 'フレックス',label2: '適用' },
        { id: 'cntrNtTgtFlag', align: 'center', width: '135px', sortTable:true, label1: '契約書対象外' },
		{ id: 'webAttdNtTgtFlag', align: 'center', width: '155px', sortTable:true, label1: 'WEB勤怠対象外' },
		{ id: 'tmpInfoRema', align: 'left', width: '345px', sortTable:true, label1: '備考' },
		{ id: 'tmpBsiContField', align: 'left', width: '345px', sortTable:true, label1: '業務内容' },
		{ id: 'tmpBsiContDta', align: 'left', width: '345px', sortTable:true, label1: '業務内容詳細' },
		{ id: 'tmpBfCntrTermSrtDate', align: 'left', width: '126px', sortTable:true, label1: '前契約期間',label2:'(開始)' },
		{ id: 'tmpBfCntrTermEndDate', align: 'left', width: '126px', sortTable:true, label1: '前契約期間', label2:'(終了)' },
		{ id: 'bfCntrHurRate', align: 'left', width: '115px', sortTable:true, label1: '前契約単価' },
		{ id: 'lastUdr', align: 'left', width: '120px', sortTable:true, label1: '最終更新者' },
		{ id: 'lastUpDate', align: 'left', width: '120px', sortTable:true, label1: '最終更新日' },
    ];
    /* ======== 編集モードのヘッダーデータ　=======*/
    /* データをコピー */
    const editHeadData = [...headData];
    /* 編集モード時に表示が切り替わるデータ */
    const editableItem1 = [
        { id: 'empNmb', align: 'left', width: '115px', sortTable:true, label1: '従業員番号' ,fixed:true,left:'0px'},
    	{ id: 'empFullName', align: 'left', width: '123px', sortTable:true, label1:'氏名',fixed:true,left:'118px', borderRight:'1px solid #c0c0c0' },
    ];
    /* 切り替わるデータを回して、置換していく */
    editableItem1.forEach((item)=>{
        const index = editHeadData.findIndex(e=>e.id === item.id);
        editHeadData.splice(index,1,item);
    });
    /*====== BodyCellの設定 ======*/
    // name		    : 項目名
    // name2		: 項目名2 値を２つ受け取りたい場合
    // type         : cellの種類　button/checkBox/lable/numLable/labelRaito/labelMonth
    // align	    : 整列(横方向) Center/inherit/justify/left/right *全て（ただしinputの場合はinputの中の文字の位置を指定）
    // width        : selectの幅調整用
    // color        : 文字の色
    // backgroundColor: 背景の色
    // checkBox     : チェックボックスの名前  *input,checkBox
    // fontSize	    : 文字の大きさ デフォルトは12px *label,labelNum
    // color	    : フォントカラーまたはアイコンカラー(アイコンの場合はred/green/grayが選択可能) *label,labelNum,iconButton
    // func         : 処理 *button,iconButton,select
    // value		: btnFuncで受け取りたい値 *button,iconButton
    const bodyData = [
        { name: 'empNmb', type: 'label',  align: 'left',fixed:true,left:'0px'},
        { name: 'empFullName', type: 'label',  align: 'left',fixed:true,left:'120px', borderRight:'1px solid #c0c0c0' },
        { name: 'empiTermDciFlag', type: 'edit',  align: 'left', masterType:'codeMaster', master:'employmentTermDisitionFlag' },
        { name: 'itrSchedTmpFlag', type: 'edit',  align: 'left', masterType:'codeMaster', master:'introductionScheduleTemporaryFlag'},
        { name: 'gendName', type: 'label',  align: 'left',},
        { name: 'tmpAgnCmpCd', name2:'tmpAgnCmpName', type: 'label',  align: 'left'},
        { name: 'entryDate', type: 'dateLabel',  align: 'left'},
        { name: 'tmpCntrTermSrtDate', type: 'dateLabel',  align: 'left'},
        { name: 'tmpCntrTermExpiDate', type: 'dateLabel',  align: 'left'},
        { name: 'rtiDate', type: 'dateLabel',  align: 'left'},
        { name: 'idiCntDate', type: 'dateLabel',  align: 'left'},
        { name: 'dptCd', type: 'label',  align: 'left'},					
        { name: 'tmpFirstDptHqName', name2:'tmpFirstDptPartName', name3:'tmpFirstDptRomName', name4:'tmpFirstDptGpName', type: 'label',  align: 'left'},
        { name: 'dptOrd', type: 'label',  align: 'left'},
        { name: 'tmpFirstRspPsnEmpNmb', type: 'label',  align: 'left'},
        { name: 'tmpFirstRspEmpFullName', type: 'label',  align: 'left'},
        { name: 'tmpFirstRspPsnPostName', type: 'label',  align: 'left'},
        { name: 'ledrEmpNmb', type: 'label',  align: 'left'},
        { name: 'ledrFullName', type: 'label',  align: 'left'},
        { name: 'ledrPostName', type: 'label',  align: 'left'},
        { name: 'workLocoName', type: 'label',  align: 'left'},
        { name: 'hurRate', type: 'moneyLabel',  align: 'right'},
        { name: 'uitCstRema', type: 'label',  align: 'left'},
        { name: 'flexAplyFlag', type: 'edit',  align: 'left', masterType:'codeMaster', master:'flexApplyFlag'},
		{ name: 'cntrNtTgtFlag', type: 'check',  align: 'center', disabled: true},
        { name: 'webAttdNtTgtFlag', type: 'check',  align: 'center' , disabled: true},
		{ name: 'tmpInfoRema', type: 'label',  align: 'left'},
		{ name: 'tmpBsiContField', type: 'label',  align: 'left'},
		{ name: 'tmpBsiContDta', type: 'label',  align: 'left'},
		{ name: 'tmpBfCntrTermSrtDate', type: 'dateLabel',  align: 'left'},
		{ name: 'tmpBfCntrTermEndDate', type: 'dateLabel',  align: 'left'},
		{ name: 'bfCntrHurRate', type: 'moneyLabel',  align: 'right'},
		{ name: 'lastUdr', type: 'label',  align: 'left'},
		{ name: 'lastUpDate', type: 'timeLabel',  align: 'left'}
    ];
    /* ======== 編集モードのテーブルデータ　=======*/
    /* データをコピー */
    const editBodyData = [...bodyData];
    /* 編集モード時に表示が切り替わるデータ */
    const editableItem2 = [
        { name: 'empNmb', type: 'label',  align: 'left',fixed:true,left:'0px'},
        { name: 'empFullName', type: 'label',  align: 'left',fixed:true,left:'118px', borderRight:'1px solid #c0c0c0' },
        { name: 'empiTermDciFlag', type: 'select',  align: 'left', masterType:'codeMaster', master: 'employmentTermDisitionFlag', required: true, deps: ['idiCntDate']},
        { name: 'itrSchedTmpFlag', type: 'select',  align: 'left', masterType:'codeMaster', master: 'introductionScheduleTemporaryFlag', required: true},
        { name: 'tmpAgnCmpCd',  name2:'tmpAgnCmpName', type: 'inputList', masterType:'master', master:'supplierMaster', align: 'left', maxLength: 200, required: true},
        { name: 'tmpCntrTermExpiDate', type: 'date', maxLength:10, align: 'left', startDate: 'tmpCntrTermSrtDate'},
        { name: 'rtiDate', type: 'date', maxLength:10, align: 'left'},
        { name: 'idiCntDate', type: 'date', maxLength:10, align: 'left', check: true, checkItem: 'empiTermDciFlag', checkValue: 'false'},
        { name: 'hurRate', type: 'input', maxLength:10, placeholder:'3000',align: 'right'},
        { name: 'uitCstRema', type: 'input', maxLength:255,placeholder:'255文字まで', align: 'left'},
        { name: 'flexAplyFlag', type: 'select', align: 'left',masterType:'codeMaster',  master: 'flexApplyFlag'},
		{ name: 'cntrNtTgtFlag', type: 'check',  align: 'center'},
        { name: 'webAttdNtTgtFlag', type: 'check',  align: 'center'},
		{ name: 'tmpInfoRema', type: 'input', maxLength:255, placeholder:'255文字まで',align: 'left'},
		{ name: 'tmpBsiContField', type: 'input', maxLength:255,placeholder:'255文字まで', align: 'left'},
		{ name: 'tmpBsiContDta', type: 'input', maxLength:255,placeholder:'255文字まで',align: 'left'},
    ];
    /* 切り替わるデータを回して、置換していく */
    editableItem2.forEach((item)=>{
        const index = editBodyData.findIndex(e=>e.name === item.name);
        editBodyData.splice(index,1,item);
    });
    /* ======== エクセルの設定 ======== */
    const excelConfig = [
        { id:'empiTermDciFlag', name:'雇用期間の定め', type:'edit', masterType:'codeMaster', master: 'employmentTermDisitionFlag'},
        { id:'itrSchedTmpFlag', name:'紹介予定派遣', type:'edit',masterType:'codeMaster', master: 'introductionScheduleTemporaryFlag'},
        { id:'empNmb', name:'従業員番号', type:'normal'},
        { id:'empFullName', name:'氏名', type:'normal'},
        { id:'gendName', name:'性別', type:'normal'},
        { id:'tmpAgnCmpCdExcel', name:'派遣元会社コード', type:'normal'},
        { id:'tmpAgnCmpNameExcel', name:'派遣元会社', type:'normal'},
        { id:'entryDate', name:'入社日(開始日)', type:'date'},
        { id:'tmpCntrTermSrtDate', name:'契約開始日', type:'date'},
        { id:'tmpCntrTermExpiDate', name:'契約満了日', type:'date'},
        { id:'rtiDate', name:'退職日(終了日)', type:'date'},
        { id:'idiCntDate', name:'個人抵触日', type:'date'},
        { id:'dptCd', name:'部署コード', type:'normal'},
        { id:'tmpFirstDptHqName', name:'本部', type:'normal'},
        { id:'tmpFirstDptPartName', name:'部', type:'normal'},
        { id:'tmpFirstDptRomName', name:'室', type:'normal'},
        { id:'tmpFirstDptGpName', name:'G', type:'normal'},
        { id:'dptOrd', name:'部署順', type:'normal'},
        { id:'tmpFirstRspPsnEmpNmb', name:'派遣先責任者', type:'normal'},
        { id:'tmpFirstRspEmpFullName', name:'派遣先責任者名', type:'normal'},
        { id:'tmpFirstRspPsnPostName', name:'派遣先責任者_役職', type:'normal'},
        { id:'ledrEmpNmb', name:'指揮命令者', type:'normal'},
        { id:'ledrFullName', name:'指揮命令者名', type:'normal'},
        { id:'ledrPostName', name:'指揮命令者_役職', type:'normal'},
        { id:'workLocoName', name:'勤務地', type:'normal'},
        { id:'hurRate', name:'時間単価', type:'normal'},
        { id:'uitCstRema', name:'時間単価備考', type:'normal'},
        { id:'flexAplyFlag', name:'フレックス', type:'edit', masterType:'codeMaster', master: 'flexApplyFlag'},
        { id:'cntrNtTgtFlag', name:'契約書対象外', type:'edit', masterType:'codeMaster', master: 'tempContractNotTargetCode'},
        { id:'webAttdNtTgtFlag', name:'WEB勤怠対象外', type:'edit', masterType:'codeMaster', master: 'tempWebAttendanceNotTargetFlag'},
        { id:'tmpInfoRema', name:'備考', type:'normal'},
        { id:'tmpBsiContField', name:'業務内容', type:'normal'},
        { id:'tmpBsiContDta', name:'業務内容詳細', type:'normal'},
        { id:'tmpBfCntrTermSrtDate', name:'前契約期間(開始)', type:'date'},
        { id:'tmpBfCntrTermEndDate', name:'前契約期間(終了)', type:'date'},
        { id:'bfCntrHurRate', name:'前契約単価', type:'normal'},
        { id:'lastUdr', name:'最終更新者', type:'normal'},
        { id:'lastUpDate', name:'最終更新日', type:'time'}
    ]
    /* ======== ページヘッダーの設定 ======== */
    // id         : 項目名
    // name       : 項目名
    // type       : 種類 input/select/checked/searchButton/clearButton
    // range      : selectbox中身
    // type       : 種類 input/select/checked/searchButton/clearButton
    // width      : 幅幅調整用
    // maxLength  : 最大桁数を定義
    // minLength  : 最小桁数を定義
    // placeholder: Input内のテキスト
    // required   : 必須定義
    // disabled   : 操作不可
    // func       : 処理 *button,iconButton,select
    // checked    :defoltCheckを定義

    /* ====== 検索欄(左)を定義 ====== */
    const searchContentsLeft = [
        {id:'sarLiteral',type:'input',name:'検索文字',placeholder:'',maxLength:50,width:'280px', pattern:'keyword'},
        {id:'search',type:'searchButton'},
        {id:'clear',type:'clearButton'},
    ];
    
    /* ====== 検索欄(右)を定義 ====== */
    const searchContentsRight = [
        {id:'excel',type:'excelButton', excelTitle:'派遣社員情報一覧', excelConfig:excelConfig}
    ];

    /* ====== 検索初期値を定義 ====== */
    const defaultSearch = {
        sarLiteral:''
    };
    /* ====== マスタの取得を定義 ====== */
    const masterList = ['supplierMaster']
    /* ---------------------------------------------------- */
    /* ----------------------- jsx ------------------------ */
    /* ---------------------------------------------------- */
   

    /* ---------------------------------------------------- */
    /* -------------------- Start Render ------------------ */
    /* ---------------------------------------------------- */

    return(
		<>
			<GetListTemp
				listType='listEditable'//一覧タイプ(list:編集なし/listEditable:編集可/listOrderBy:表示順更新)
				initialSearch={true}//初期検索
                searchCount={true}//検索件数表示
				pageTitle='派遣社員情報一覧'//画面タイトル
				searchContentsLeft={searchContentsLeft}//検索欄左設定
				searchContentsRight={searchContentsRight}//検索欄右設定
				apiPath='/employee/getlisttemporaryemployee'//一覧取得のApiPath
				updateApiPath='/employee/updatelisttemporaryemployee'//更新のApiPath
				headData={headData}//テーブルヘッダ設定
                editHeadData={editHeadData}//テーブルヘッダ設定(編集用)
				bodyData={bodyData}//テーブルボディ設定
				editBodyData={editBodyData}//テーブルボディ設定(編集用)
				getConfig={getConfig}//テーブル取得設定🌟
				updateConfig={updateConfig}//テーブル更新設定
                defaultSearch={defaultSearch}//初期検索値🌟
                masterList={masterList}//マスター設定
			/>
		</>
	)
};

/* ======================================================================================================================================================= */  
/* ==================================================================== End Of Program =================================================================== */  
/* ======================================================================================================================================================= */ 